module.exports = __webpack_public_path__ + "static/media/ic_lock.a86e3ba2.svg";